
import { defineComponent } from 'vue';
import store from '@/store';

interface MenuItem {
    name: string;
    title: string;
    icon: string;
}

export default defineComponent({
    name: 'SidebarComponent',
    data() {
        return {
            menuGroups: [
                {
                    title: 'مدیریت',
                    items: [
                        { name: 'Services', title: 'داشبورد', icon: 'mdi-view-dashboard-outline' },
                        { name: 'Users', title: 'کاربران', icon: 'mdi-account-group-outline' },
                        { name: 'Reports', title: 'گزارشات', icon: 'mdi-file-chart-outline' }
                    ]
                },
                {
                    title: 'عملیات مالی',
                    items: [
                        { name: 'Transactions', title: 'تراکنش‌ها', icon: 'mdi-swap-horizontal' },
                        { name: 'ManualCharges', title: 'شارژهای دستی', icon: 'mdi-cash-plus' },
                        { name: 'Gateways', title: 'درگاه‌ها', icon: 'mdi-bank-outline' },
                        { name: 'Exchange', title: 'صرافی', icon: 'mdi-currency-usd' }
                    ]
                },
                {
                    title: 'سامانه',
                    items: [
                        { name: 'platform-logs', title: 'لاگ سیستم', icon: 'mdi-text-box-search-outline' },
                        { name: 'Settings', title: 'تنظیمات', icon: 'mdi-cog-outline' }
                    ]
                }
            ] as { title: string; items: MenuItem[] }[]
        };
    },
    computed: {
        sidebarStatus(): boolean {
            return store.getters['app/getSidebarStatus'];
        }
    },
    watch: {
        $route() {
            this.closeSidebar();
        }
    },
    methods: {
        isActive(item: MenuItem): boolean {
            return this.$route.name === item.name;
        },
        closeSidebar(): void {
            if (this.sidebarStatus) store.dispatch('app/toggleSidebarStatus');
        }
    }
});
